import {CategoryStatistics} from "..";

function MetricsStatistics({ data, isMobile, hiddenMetricKeys = [], isLoading = false }) {
  const METRICS = [
    { key: "shows", title: "Показы" },
    { key: "reach", title: "Охваты" },
    { key: "clicks", title: "Клики" },
    { key: "leads", title: "Лиды" },
    { key: "spent", title: "Расход (₽)" },
    { key: "ctr", title: "CTR (%)" },
    { key: "cpc", title: "CPC ( ₽)" },
    { key: "ecpm", title: "eCPM ( ₽)" },
    { key: "cr", title: "CR (%)" },
    { key: "cpa", title: "CPA" },
  ];
  const indexByKey = METRICS.reduce((acc, m, idx) => ({ ...acc, [m.key]: idx }), {});
  const visibleMetrics = METRICS.filter(m => !hiddenMetricKeys.includes(m.key));
  function numberWithSpaces(number) {
    if(number < 10000) return number
    return number.toString().replace(/\B(?=(\d{3})+(?!\d))/g, " ");
  }
  function numberToFixcedWithSpaces(number) {
    var parts = number.toString().split(".");
    if(number < 10000) return number
    parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, " ");
    return parts.join(".");
  }
  return (
    <div
      className={isMobile ? "container metrics-scroll" : "container"}
      style={
        isMobile
          ? {
              display: "flex",
              flexWrap: "nowrap",
              overflowX: "auto",
              gap: 8,
              marginBottom: 0,
              paddingBottom: 8,
              WebkitOverflowScrolling: "touch"
            }
          : {
              display: "flex",
              justifyContent: "center",
              marginBottom: 0,
              gap: 8,
              transform: "scale(0.8)"
            }
      }
    >
      {visibleMetrics.map((metric) => {
        const idx = indexByKey[metric.key];
        const value = data?.[idx];
        const isIntegerMetric = [0, 1, 2, 3, 4].includes(idx);
        const shouldShowDash = isLoading || (value === null || value === undefined);
        return (
          <CategoryStatistics
            title={metric.title}
            key={metric.key}
            amount={
              shouldShowDash
                ? "-"
                : isIntegerMetric
                  ? numberWithSpaces(Number(value).toFixed(0))
                  : numberToFixcedWithSpaces(Number(value).toFixed(2))
            }
          />
        );
      })}
    </div>
  );
}

export default MetricsStatistics;